export default __webpack_public_path__ + "static/media/s-3.49ae50fa.jpg";